import { useMetadataHeader } from './useMetadataHeader';

import { userAgentHeader } from 'features/sip/constants';

/**
 * Returns the SIP headers to use for a given type of SIP call or answer.
 * The result is an array of strings that can be passed to .call or .answer.
 */
export function useSipHeaders(options?: {
  isRemoteMercuryCall: boolean;
}): string[] {
  const sinfo = useMetadataHeader().metadataHeader;
  const wavello = 'P-SORENSON-CAPABILITIES: WAVELLO_T';
  const dtmf = 'Recv-Info: DTMF';

  const result = [userAgentHeader, wavello, dtmf];
  if (!options?.isRemoteMercuryCall) {
    result.push(sinfo);
  }

  return result;
}
